// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2FjAq","actions":"GroupTable_actions__SkP9A","deleteModalFooter":"GroupTable_deleteModalFooter__3w_gt"};